import Client from "../clients/model";
import { cloneDeep } from "lodash";
import { make } from "vuex-pathify";
import store from "../..";
import Tag from "./model";

const state = {
    loading: false,
    creating: false,
    updating: false,
    destroying: false,
    tags: [],
};

const mutations = make.mutations(state);

const actions = {
    async loadTags({ commit }, filter = true) {
        let client = new Client({id: store.get('auth/client@id')})
        let tag = new Tag().for(client)
        let tags = null;

        try {
            commit("loading", tag.get())
            tags = await store.get("tags/loading")

            commit("loading", false)
        } catch (error) {
        //
        }

        commit("tags", tags.data);
    },

    async destroy({commit, dispatch}, payload) {
        let tag = new Tag(payload)

        try {
            commit("loading", tag.delete());
            await store.get("tags/loading");
            commit("loading", false);
        } catch (error) {
            throw error
        }
    },
};

const getters = {
    //
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
